import { useLocation, useParams } from "react-router-dom";
import Transactions from "../../Transactions/Main";


const UserTransactions = () => {
    const location = useLocation();
    const { userId } = useParams();
    const userData = location.state || { id: userId };

    return (
        <div style={{marginTop: -24}}>
            <Transactions showHeader={false} type={"apiType"} data={userData} />
        </div>
    );
}

export default UserTransactions;
